import classnames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import MediaQuery from "react-responsive"
import useSyncedScroll from "react-usesyncedscroll"

import { withTranslation } from "../../i18n/translate"
import { getMediaQuery, smallPhone, tablet } from "../../util/media-queries"
import MenuOverlay from "../menu-overlay/menu-overlay"
import Tile from "../tile/tile"
import "./split-layout.sass"

const withSyncedScroll = (conf) => {
  return (WrappedComponent) =>
    ({ ...props }) => {
      const [syncContainer1Ref, syncContainer2Ref] = useSyncedScroll(conf)

      return (
        <WrappedComponent
          syncContainer1Ref={syncContainer1Ref}
          syncContainer2Ref={syncContainer2Ref}
          {...props}
        />
      )
    }
}

class SplitLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      isMobile: false,
      isClient: false,
    }
  }

  componentDidMount() {
    this.setState({
      isClient: true,
    })
  }

  toggleSidebar() {
    this.setState({ active: !this.state.active })
  }

  render() {
    const {
      children,
      sidebar,
      header,
      mobileHeader,
      sidebarTitleTranslationKey,
      syncContainer1Ref,
      syncContainer2Ref,
    } = this.props

    const actions = { toggleSidebar: () => this.toggleSidebar() }

    const { t } = this.props

    return (
      <>
        {header}

        {mobileHeader && this.state.isClient && (
          <MediaQuery {...getMediaQuery(smallPhone, tablet)}>
            <div className={"_fp-split-layout__mobile-nav-bar"}>
              {mobileHeader(actions)}
            </div>
            <div className="_fp-split-layout__mobile-nav-bar-spacer" />
          </MediaQuery>
        )}

        <div className="_fp-global-container">
          <div
            className={classnames("_fp-split-layout", {
              "_fp-split-layout--loading": !this.state.isClient,
            })}
          >
            <div className={"_fp-split-layout__sidebar"}>
              <div ref={syncContainer1Ref}>
                <MediaQuery {...getMediaQuery(smallPhone, tablet)}>
                  {(matches) =>
                    matches && this.state.isClient ? (
                      <MenuOverlay
                        state={this.state.active}
                        titleTranslationKey={sidebarTitleTranslationKey}
                        setState={(s) => this.setState({ active: s })}
                      >
                        {sidebar}
                      </MenuOverlay>
                    ) : (
                      <Tile
                        tileSize={"s"}
                        titleTranslatedString={t(sidebarTitleTranslationKey)}
                      >
                        {sidebar}
                      </Tile>
                    )
                  }
                </MediaQuery>
              </div>
            </div>
            <div className="_fp-split-layout__content">
              <div ref={syncContainer2Ref}>{children}</div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

SplitLayout.propTypes = {
  sidebarTitleTranslationKey: PropTypes.string,
  header: PropTypes.node.isRequired,
  sidebar: PropTypes.node.isRequired,
  mobileHeader: PropTypes.func,
  scrollSynced: PropTypes.bool,
}

export default withTranslation()(
  withSyncedScroll({ snapTo: "top", topPadding: 180, bottomPadding: 30 })(
    SplitLayout,
  ),
)
